import React from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { Formik, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
  justificativa: Yup.string()
    .required('Justificativa é obrigatória')
    .max(500, 'Máximo 500 caracteres'),
});

const ModalAprovar = ({ show, quantidade, onHide, onConfirmar }) => {
  const handleSubmit = (values, formikBag) => {
    formikBag.setSubmitting(false);
    onConfirmar(values.justificativa);
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton style={{ backgroundColor: '#28a745', color: '#fff' }}>
        <Modal.Title style={{ fontSize: '1rem', color: '#fff' }}>
          Aprovar Pagamento{quantidade !== 1 ? 's' : ''}
        </Modal.Title>
      </Modal.Header>

      <Formik
        initialValues={{ justificativa: '' }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {(formik) => (
          <Form onSubmit={formik.handleSubmit}>
            <Modal.Body>
              <p className="text-muted" style={{ fontSize: '0.9rem' }}>
                Você está aprovando <strong>{quantidade}</strong> pagamento(s).
                Informe a justificativa para a aprovação:
              </p>
              <Form.Group className="mb-2">
                <Form.Label className="font-weight-bold">
                  Justificativa <span className="text-danger">*</span>
                </Form.Label>
                <Field
                  as="textarea"
                  name="justificativa"
                  className={`form-control${formik.touched.justificativa && formik.errors.justificativa ? ' is-invalid' : ''}`}
                  rows={4}
                  maxLength={500}
                  placeholder="Descreva o motivo da aprovação..."
                />
                <ErrorMessage
                  name="justificativa"
                  component="div"
                  className="invalid-feedback d-block"
                />
                <Form.Text className="text-muted">
                  {(formik.values.justificativa || '').length}/500 caracteres
                </Form.Text>
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={onHide} disabled={formik.isSubmitting}>
                Cancelar
              </Button>
              <Button variant="success" type="submit" disabled={formik.isSubmitting}>
                Confirmar Aprovação
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default ModalAprovar;
